// extracted by mini-css-extract-plugin
export var loading = "_2ALeKpSQ";
export var wholeScreen = "v03O0VVK";
export var stretched = "Ec8PGOIZ";